import {
  Button,
  ButtonGroup,
  FilePicker,
  Modal,
  Select,
  TextArea,
  TextBox,
} from "@veneer/core";
import { useTranslation } from "react-i18next";
import { usePublisherModalViewModel } from "./usePublisherModalViewModel";
import { ModalInformational } from "../../SellOut/SellOutComponent/ModalInformational";
import { useEffect } from "react";
import LoadingModal from "./LoadingModal";

interface IProps {
  openCreatePost: boolean;
  handleOpenCreatePost: (value: boolean) => void;
  isUpdate: boolean;
  updatePostID?: number;
}

const CreatePublisherModal = ({
  openCreatePost,
  handleOpenCreatePost,
  isUpdate,
  updatePostID,
}: IProps) => {
  const [t] = useTranslation("global");
  const {
    inputValues,
    isButtonValid,
    subregionOptions,
    roleOptions,
    loading,
    createStatus,
    userId,
    userIdLogged,
    onChangeSubregion,
    onClearSubregion,
    onChangeRole,
    onClearRole,
    handleInputValues,
    handleFileChange,
    onClearFilePicker,
    handleSavePost,
    handleCloseCreateStatus,
    getPublisherDataToUpdate,
    handleUpdatePost,
    cleanInputValues,
  } = usePublisherModalViewModel();

  const canSave = isUpdate ? userId === userIdLogged : true;

  const handleOnClickMessage = () => {
    handleCloseCreateStatus();
    handleOpenCreatePost(false);
    window.location.reload();
  };

  useEffect(() => {
    if (isUpdate && updatePostID && updatePostID > 0) {
      getPublisherDataToUpdate(updatePostID);
    }
  }, [isUpdate, updatePostID]);

  return (
    <>
      <Modal
        align="start"
        id="modal-create"
        show={openCreatePost}
        onClose={() => {
          handleOpenCreatePost(false);
          cleanInputValues();
        }}
        footer={
          <ButtonGroup>
            <Button
              disabled={!isButtonValid || !canSave}
              onClick={() => {
                isUpdate && updatePostID && updatePostID > 0
                  ? handleUpdatePost(updatePostID)
                  : handleSavePost();
              }}
            >
              {isUpdate && updatePostID && updatePostID > 0
                ? t("header.update")
                : t("header.save")}
            </Button>
            <Button
              appearance="secondary"
              onClick={() => {
                handleOpenCreatePost(false);
                cleanInputValues();
              }}
            >
              {t("header.cancel")}
            </Button>
          </ButtonGroup>
        }
        title={t("header.createPost")}
      >
        {loading ? (
          <LoadingModal />
        ) : (
          <div className="modal-content-publisher">
            <TextBox
              id="title"
              label={t("header.title")}
              placeholder={t("header.title")}
              onChange={(e) => handleInputValues("title", e)}
              value={inputValues.title}
              required
            />
            <TextArea
              id="text-area"
              label={t("header.description")}
              placeholder={t("header.description")}
              onChange={(e) => handleInputValues("description", e)}
              value={inputValues.description}
              required
            />
            <FilePicker
              key={openCreatePost ? "open" : "closed"}
              id="file-picker"
              accept=".jpg,.jpeg,.png"
              label={t("header.image")}
              onChange={(e, file, value) =>
                handleFileChange(e, file, value, "imageUrl")
              }
              onClear={() => onClearFilePicker("imageUrl")}
            />
            <FilePicker
              id="file-picker"
              accept=".pdf"
              label={t("header.pdf")}
              placeholder={t("header.pdf")}
              onChange={(e, file, value) =>
                handleFileChange(e, file, value, "pdfUrl")
              }
              onClear={() => onClearFilePicker("pdfUrl")}
            />
            <TextBox
              id="video"
              label={t("header.video")}
              placeholder={t("header.videoUrl")}
              onChange={(e) => handleInputValues("video", e)}
              value={inputValues.video}
            />
            <TextBox
              id="url"
              label={t("header.url")}
              placeholder={t("header.url")}
              onChange={(e) => handleInputValues("url", e)}
              value={inputValues.url}
            />
            <Select
              options={subregionOptions}
              id="select-usage"
              label="Sub-region"
              placement="bottom"
              helperTextVisibility="auto"
              onChange={onChangeSubregion}
              onClear={onClearSubregion}
              value={inputValues.subregionValues}
              multiple
            />
            <Select
              options={roleOptions}
              id="select-usage"
              label={t("header.role")}
              placement="bottom"
              helperTextVisibility="auto"
              onChange={onChangeRole}
              onClear={onClearRole}
              value={inputValues.roleValues}
              multiple
            />
          </div>
        )}
      </Modal>

      <ModalInformational
        idKey="modal-CreateOk"
        setOpenCloseModal={handleOnClickMessage}
        openModal={createStatus === true ? true : false}
        titleMessage={t("modal.message")}
        message={t("modal.messageCratedPost")}
        onClickOk={handleOnClickMessage}
      />

      <ModalInformational
        idKey="modal-Error"
        setOpenCloseModal={handleOnClickMessage}
        openModal={createStatus === false ? true : false}
        titleMessage={t("modal.message")}
        message={t("modal.generalError")}
        onClickOk={handleOnClickMessage}
      />
    </>
  );
};

export default CreatePublisherModal;
